import { createStyle } from "~/common/utils/create-style";
import { IconChevronDown } from "~/common/components/icons/chevron-down";

function MenuExpand({
  onClick,
  isExpanded,
}: {
  onClick: () => void;
  isExpanded: boolean;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={menuExpandStyle.container()}
      aria-expanded={isExpanded}
      aria-label={isExpanded ? "Show less" : "Show more"}
      data-test={`show-${isExpanded ? "less": "more"}-btn`}
    >
      <span className={menuExpandStyle.icon({ isExpanded })}>
        <IconChevronDown />
      </span>
    </button>
  );
}

const menuExpandStyle = createStyle({
  slots: {
    container: [
      "w-full flex justify-center p-8 pb-[0.9rem]",
      "border-b border-border-solid-on-dark-10  text-text-tertiary-on-dark",
      "hover:cursor-pointer hover:border-b-2 hover:border-solid-on-dark-20 hover:pb-8",
    ],
    icon: "",
  },
  variants: {
    isExpanded: {
      true: {
        icon: "rotate-180",
      },
      false: {
        icon: "",
      },
    },
  },
})();

export { MenuExpand };
